export interface ExpandContentProps {
  open: Boolean;
  children: React.ReactNode;
}

export default function ExpandContent(props: ExpandContentProps) {
  const { open, children } = props;
  return (
    <div
      className={`
    overflow-hidden transition-all duration-300 ease-in-out 
    ${open ? "max-h-[1000px]" : "max-h-0"}
  `}
    >
      {children}
    </div>
  );
}
